export function getPlanSeconds(planTime) {
  if (!planTime) return 0
  return (
    (Number(planTime.days) || 0) * 86400 +
    (Number(planTime.hours) || 0) * 3600 +
    (Number(planTime.minutes) || 0) * 60 +
    (Number(planTime.seconds) || 0)
  )
}
